export default __webpack_public_path__ + "static/media/use-template.82e42d49.svg";